import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { Calendar } from "react-feather";
import { Input } from "reactstrap";
import moment from "moment";
import "./income-period-datepicker.scss";

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const POPPER_MODIFIERS = [
  { name: "offset", options: { offset: [0, 8] } },
  {
    name: "zIndex",
    enabled: true,
    phase: "write",
    fn: ({ state }) => {
      state.styles.popper.zIndex = 1050;
    },
  },
];

export default function IncomePeriodDatePicker({
  selected,
  onChange,
  minDate,
  maxDate,
  placeholder = "Select date",
  invalid = false,
  selectsStart,
  selectsEnd,
  startDate,
  endDate,
  variant = "default",
}) {
  const [yearPickerOpen, setYearPickerOpen] = useState(false);

  const handleChange = (date) => {
    onChange(date);
    if (yearPickerOpen) setYearPickerOpen(false);
  };

  const inputValue = selected ? moment(selected).format("YYYY-MM-DD") : "";

  const customInput =
    variant === "modal" ? (
      <input
        type="text"
        className="form-control"
        value={inputValue}
        placeholder={placeholder}
        readOnly
      />
    ) : (
      <div className="inc-period-dp__input-wrap">
        <Input
          type="text"
          value={inputValue}
          placeholder={placeholder}
          readOnly
          invalid={invalid}
          className="inc-period-dp__input"
        />
        <Calendar size={18} color="#d41515" className="inc-period-dp__icon" aria-hidden="true" />
      </div>
    );

  return (
    <div className="inc-period-dp">
      <DatePicker
        selected={selected}
        onChange={handleChange}
        minDate={minDate}
        maxDate={maxDate}
        selectsStart={selectsStart}
        selectsEnd={selectsEnd}
        startDate={startDate}
        endDate={endDate}
        dateFormat="yyyy-MM-dd"
        placeholderText={placeholder}
        showPopperArrow={false}
        showYearPicker={yearPickerOpen}
        calendarClassName="inc-period-dp__calendar"
        popperClassName="inc-period-dp__popper"
        popperPlacement="bottom-start"
        popperModifiers={POPPER_MODIFIERS}
        openToDate={selected || maxDate || new Date()}
        yearItemNumber={16}
        onCalendarClose={() => setYearPickerOpen(false)}
        customInput={customInput}
        renderCustomHeader={(props) => {
          if (yearPickerOpen) {
            return (
              <div className="inc-dp-header inc-dp-header--years">
                <button
                  type="button"
                  className="inc-dp-header__back"
                  onClick={() => setYearPickerOpen(false)}
                >
                  ← Back
                </button>
                <span className="inc-dp-header__title">Select year</span>
                <button
                  type="button"
                  className="inc-dp-header__nav"
                  onClick={props.decreaseYear}
                  disabled={props.prevYearButtonDisabled}
                  aria-label="Earlier years"
                >
                  ‹
                </button>
                <button
                  type="button"
                  className="inc-dp-header__nav"
                  onClick={props.increaseYear}
                  disabled={props.nextYearButtonDisabled}
                  aria-label="Later years"
                >
                  ›
                </button>
              </div>
            );
          }

          return (
            <div className="inc-dp-header">
              <button
                type="button"
                className="inc-dp-header__nav"
                onClick={props.decreaseMonth}
                disabled={props.prevMonthButtonDisabled}
                aria-label="Previous month"
              >
                ‹
              </button>
              <div className="inc-dp-header__center">
                <span className="inc-dp-header__month">{MONTHS[props.date.getMonth()]}</span>
                <button
                  type="button"
                  className="inc-dp-header__year"
                  onClick={() => setYearPickerOpen(true)}
                >
                  {props.date.getFullYear()}
                </button>
              </div>
              <button
                type="button"
                className="inc-dp-header__nav"
                onClick={props.increaseMonth}
                disabled={props.nextMonthButtonDisabled}
                aria-label="Next month"
              >
                ›
              </button>
            </div>
          );
        }}
      />
    </div>
  );
}
